import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { StyledMenu } from './BurgerMenuStyles.styles';
import { Link } from 'react-router-dom';
import { FaTimes } from 'react-icons/fa';
import Auth from '../../../Helpers/auth';

// React Icons for menu items
import {
  FiSettings,
  FiUsers,
  FiCreditCard,
  FiLogOut,
  FiBookOpen,
  FiGrid,
  FiFileText,
  FiAward,
  FiChevronDown,
  FiChevronRight,
  FiFile,
} from 'react-icons/fi';

const groupedLinks = [
  { path: '/', label: 'Home' },
  { path: '/about', label: 'About Us' },
  // { path: '/news', label: 'News & Updates' },
  // { path: '/resources', label: 'Resources' },
  {
    label: 'News & Resources',
    children: [
      { path: '/news', label: 'Newsletter' },
      { path: '/resources', label: 'Resources' },
      { path: '/safety-audits', label: 'Safety Audits' },
      { path: '/safety-manuals', label: 'Safety Manuals' },
      { path: '/digital-safety-forms', label: 'Digital Safety Forms' },
    ],
  },
  {
    label: 'Training',
    children: [
      { path: '/training', label: 'Online Training' },
      { path: '/company-training', label: 'Company Training' },
    ],
  },

  {
    label: 'Shop',
    children: [
      { path: '/explore-products', label: 'Explore Products' },
      { path: '/shop', label: 'How To Purchase' },
    ],
  },

  {
    label: 'Support',
    children: [{ path: '/contact-us', label: 'Contact Us' }],
  },
];

const Menu = ({ open, setOpen }) => {
  const [openSections, setOpenSections] = useState({});
  const closeMenu = () => {
    setOpen(!open);
  };

  const toggleSection = (label) => {
    setOpenSections((prev) => ({ ...prev, [label]: !prev[label] }));
  };

  // Use Auth.getProfile() consistently and guard access checks
  const profile = Auth.loggedIn() ? Auth.getProfile() : { data: {} };
  const user = profile?.data || {};
  const url = user?.id ? `/user/settings/${user.id}` : '/user/settings';
  const subcontractorAccess =
    JSON.parse(sessionStorage.getItem('subcontractorAccess')) || false;

  return (
    <StyledMenu open={open}>
      <div className="topNav" open={open} onClick={() => setOpen(!open)}>
        <FaTimes
          style={{
            fontSize: 'var(--space-xl)',
            color: 'var(--yellow4)',
            cursor: 'pointer',
          }}
        />
      </div>
      <div className="bottomNav">
        {/* DASHBOARDS */}
        <div className="menuSection">
          {groupedLinks.map((link) =>
            link.children ? (
              <div key={link.label}>
                <button
                  type="button"
                  onClick={() => toggleSection(link.label)}
                  aria-expanded={!!openSections[link.label]}
                  style={{
                    all: 'unset',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    width: '100%',
                  }}
                >
                  <span className="parentLink">{link.label}</span>
                  <span style={{ marginLeft: 'auto' }}>
                    {openSections[link.label] ? (
                      <FiChevronDown />
                    ) : (
                      <FiChevronRight />
                    )}
                  </span>
                </button>
                {openSections[link.label] && (
                  <div className="subLinks">
                    {link.children.map((child) => (
                      <Link
                        key={child.path}
                        to={child.path}
                        onClick={closeMenu}
                      >
                        {child.label}
                      </Link>
                    ))}
                  </div>
                )}
              </div>
            ) : (
              <Link key={link.path} to={link.path} onClick={closeMenu}>
                {link.label}
              </Link>
            )
          )}
        </div>
        {Auth.loggedIn() && (
          <div className="menuSection">
            <div className="menuSubtitle">DASHBOARD</div>

            {user?.type === 'Admin' ? (
              <>
                <Link to="/admin" onClick={closeMenu}>
                  <FiGrid style={{ marginRight: 'var(--space-s)' }} />
                  Admin Dashboard
                </Link>
                <Link to="/user" onClick={closeMenu}>
                  <FiGrid style={{ marginRight: 'var(--space-s)' }} />
                  User Dashboard
                </Link>
              </>
            ) : user?.type === 'Manager' ? (
              <Link to="/manager" onClick={closeMenu}>
                <FiUsers style={{ marginRight: 'var(--space-s)' }} />
                My Dashboard
              </Link>
            ) : (
              <Link to="/user" onClick={closeMenu}>
                <FiBookOpen style={{ marginRight: 'var(--space-s)' }} />
                Your Dashboard
              </Link>
            )}

            {(process.env.REACT_APP_PRODUCTION === undefined ||
              process.env.REACT_APP_PRODUCTION === 'false') && (
              <Link
                to={
                  subcontractorAccess
                    ? '/subcontractor'
                    : '/subcontractor/login'
                }
                onClick={closeMenu}
              >
                <FiUsers style={{ marginRight: 'var(--space-s)' }} />
                Subcontractor Dashboard
              </Link>
            )}
          </div>
        )}
        {/* ACTIONS */}
        <div className="menuSection">
          {Auth.loggedIn() && (
            <>
              <div className="menuSubtitle">ACTIONS</div>

              <Link to="/user/all-courses" onClick={closeMenu}>
                <FiBookOpen style={{ marginRight: 'var(--space-s)' }} />
                Your Courses
              </Link>
              <Link to="/training" onClick={closeMenu}>
                <FiCreditCard style={{ marginRight: 'var(--space-s)' }} />
                Purchase Courses
              </Link>
              {/* <Link to="/explore-products" onClick={closeMenu}>
                <FiCreditCard style={{ marginRight: 'var(--space-s)' }} />
                Explore Products
              </Link>
              <Link to="/shop" onClick={closeMenu}>
                <FiCreditCard style={{ marginRight: 'var(--space-s)' }} />
                Shop
                <div style={{ fontSize: '0.9rem', opacity: 0.8 }}>
                  How to Purchase Products
                </div>
              </Link> */}
              {(process.env.REACT_APP_PRODUCTION === undefined ||
                process.env.REACT_APP_PRODUCTION === 'false') && (
                <Link to="/user/certificates" onClick={closeMenu}>
                  <FiAward style={{ marginRight: 'var(--space-s)' }} />
                  Certificates
                </Link>
              )}
              {user?.company?.[0]?.companyId?._id && (
                <Link
                  to={`/user/forms/${user.company[0].companyId._id}`}
                  onClick={closeMenu}
                >
                  <FiFile style={{ marginRight: 'var(--space-s)' }} />
                  Forms
                </Link>
              )}
            </>
          )}
          {/* Public links */}
        </div>

        {/* SETTINGS */}
        {Auth.loggedIn() && (
          <div className="menuSection">
            <div className="menuSubtitle">SETTINGS</div>
            <Link to="/user/purchase-history" onClick={closeMenu}>
              <FiFileText style={{ marginRight: 'var(--space-s)' }} />
              Purchase History
            </Link>
            <Link to={url} onClick={closeMenu}>
              <FiSettings style={{ marginRight: 'var(--space-s)' }} />
              Settings
            </Link>
          </div>
        )}

        {/* LOGOUT */}
        <div className="menuSection">
          {/* <div className="menuSubtitle">LOGOUT</div> */}
          {Auth.loggedIn() ? (
            <Link
              onClick={(e) => {
                e.preventDefault();
                // close the menu first, then log out and redirect
                closeMenu();
                Auth.logout();
                window.location.assign('/');
              }}
              title="Logout"
              to="/about"
            >
              <FiLogOut style={{ marginRight: 'var(--space-s)' }} />
              Logout
            </Link>
          ) : (
            <Link
              to="/login"
              onClick={closeMenu}
              className="pillButton"
              aria-label="Login"
            >
              Login
            </Link>
          )}
        </div>
      </div>
    </StyledMenu>
  );
};

Menu.propTypes = {
  open: PropTypes.bool,
  setOpen: PropTypes.func,
};

export default Menu;
